export const distributionTypeExplanations = {
  custom: {
    name: 'Custom',
    description: 'Expenses will be split between individuals at a fixed percentage.',
  },
  proportional_by_income: {
    name: 'Proportional by Income',
    description: 'Expenses will be split between individuals dynamically each year based on their total net income at the time.',
  },
  proportional_by_discretionary_investments: {
    name: 'Proportional by Discretionary Investments',
    description: 'Expenses will be split between individuals dynamically each year based on their total discretionary capital at the time.',
  }
}
